// import _ from 'lodash';
import _ from 'lodash';
import axios from 'axios';
import configService from '@/services/configService';
import utils from '@/helper/utils';

export default {
  async listProducts({ id, query = {} } = {}) {
    const pickedQuery = _.pick(query, []);
    let url = `${configService.get('apiUrl')}/product-catalogue/${id}`;
    if (pickedQuery) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }

    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async listStore({ query = {} } = {}) {
    const pickedQuery = _.pick(query, ['q', 'pincode']);
    let url = `${configService.get('apiUrl')}/store/pincode`;
    if (pickedQuery) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }

    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async postOne({ order } = {}) {
    return axios
      .post(`${configService.get('apiUrl')}/order/open`, order)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  }
};
